// would be called from the component to dispatch the action
export const GET_PROVIDER_DATA = "GET_PROVIDER_DATA";
export const GET_PROVIDER_CATEGORIES = "GET_PROVIDER_CATEGORIES";

// interal action names which would be used by the saga effects to update the data
const ACTION_LOADER = "ACTION_LOADER";
const SET_PROVIDER_DATA = "SET_PROVIDER_DATA";
const SET_PROVIDER_CATEGORIES = "SET_PROVIDER_CATEGORIES";

const SET_PROVIDER_SEARCH_QUERY = "SET_PROVIDER_SEARCH_QUERY";

export const getProviderSearchData = (payload) => ({
    type: GET_PROVIDER_DATA,
    payload,
});

export const getProviderCategoryData = () => ({
    type: GET_PROVIDER_CATEGORIES,
});

export const setProviderSearchData = (providerSearchData) => ({
    type: SET_PROVIDER_DATA,
    providerSearchData,
});

export const setProviderSearchQueryState = (providerSearchQueryByAddress) => ({
    type: SET_PROVIDER_SEARCH_QUERY,
    providerSearchQueryByAddress,
});
export const setProviderCategoryData = (providerCategory) => ({
    type: SET_PROVIDER_CATEGORIES,
    providerCategory,
});

export const setLoaderState = (loadingState) => ({
    type: ACTION_LOADER,
    loadingState,
});

const initialState = {
    providerSearchData: {},
    providerCategory: [],
    providerSearchQueryByAddress: {},
    isLoading: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_PROVIDER_DATA:
            const { providerSearchData } = action;
            return { ...state, providerSearchData: providerSearchData };
        case SET_PROVIDER_CATEGORIES:
            const { providerCategory } = action;
            return { ...state, providerCategory: providerCategory };
        case SET_PROVIDER_SEARCH_QUERY:
            const { providerSearchQueryByAddress } = action;
            return {
                ...state,
                providerSearchQueryByAddress: {
                    searchText: providerSearchQueryByAddress?.searchText,
                    specialty: providerSearchQueryByAddress?.specialty,
                },
            };
        case ACTION_LOADER:
            return { ...state, isLoading: action.loadingState };
        default:
            return state
    }
}